import React from 'react';

const LeftArrow = ({ height = '12px', width = '12px', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 9 9" {...rest}>
    <path d="M0 4.5L9 0v9z" />
  </svg>
);

export default LeftArrow;
